// extracted by mini-css-extract-plugin
module.exports = {"MONTH":"atH3HG","month":"atH3HG","DAY":"B5Lg1P","day":"B5Lg1P","YEAR":"WV9b6R","year":"WV9b6R","fields":"wokH5x","mobile":"Sg9D5h"};